
import { useState } from 'react';

export default function FAQSection() {
  const [openFAQ, setOpenFAQ] = useState<number | null>(null);

  const faqs = [
    {
      question: "¿Dónde será la sesión de fotos?",
      answer: "Estas sesiones se realizarán en la Urb. Valles de Patillas, Patillas P.R"
    },
    {
      question: "¿Cuánto es el depósito para Reservación?",
      answer: "El depósito para reservar su sesión de fotos en Navidad es de $100. Puede realizar el pago a través de ATH Móvil, Klarna, PayPal y Tarjeta de Crédito. Al momento de reservar, recibirá toda la información."
    },
    {
      question: "Política de Cancelación",
      answer: "El adelanto inicial NO es reembolsable. Cualquier cancelación de nuestros servicios surgida por consecuencia de enfermedad, u otra razón, por la cual haya que cancelar la sesión de fotografías, el depósito inicial no es reembolsable y el mismo quedará como crédito para utilizarse durante los próximos 10 meses en cualquier tipo de servicios ofrecido por Idoel Photography."
    },
    {
      question: "¿Cuántas personas pueden participar en las sesiones de navidad?",
      answer: "Las sesiones navideñas solo son válidas para grupo o familias de hasta 6 integrantes. Si deseas que otros participen deberá realizar otra reservación."
    },
    {
      question: "¿En cuánto tiempo recibiré las fotos?",
      answer: "Todo dependerá del flujo de trabajo, pero quiero que tus fotos estén listas antes de navidad, por lo regular se estima en 48 horas."
    },
    {
      question: "¿Cómo me entregarán las fotos?",
      answer: "Después de la sesión de fotografías, las mismas se entregarán en formato digital a través de email. También estarán disponibles en nuestra página web; www.idoelphotography.com por un tiempo limitado."
    },
    {
      question: "¿Cuáles son los Términos y Condiciones?",
      answer: "Puede ver los términos y condiciones al momento de comenzar su reservación."
    }
  ];

  const toggleFAQ = (index: number) => {
    setOpenFAQ(openFAQ === index ? null : index);
  };

  return (
    <section className="py-16 sm:py-20 px-4 sm:px-6 relative bg-black">
      {/* Fondo estrellado sutil */}
      <div className="absolute inset-0">
        {[...Array(25)].map((_, i) => (
          <div
            key={i}
            className="absolute animate-pulse opacity-15"
            style={{
              left: `${Math.random() * 100}%`,
              top: `${Math.random() * 100}%`,
              animationDelay: `${Math.random() * 3}s`,
              animationDuration: `${3 + Math.random() * 2}s`
            }}
          >
            <div className="w-0.5 h-0.5 rounded-full bg-gold-500"></div>
          </div>
        ))}
      </div>

      <div className="max-w-4xl mx-auto relative z-10">
        {/* Título de la sección */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 sm:mb-6 leading-tight font-serif text-gold-500">
            Preguntas Frecuentes
          </h2>
          <div className="w-16 sm:w-24 h-px mx-auto mb-6 sm:mb-8 bg-gradient-to-r from-transparent via-gold-500 to-transparent"></div>
          <p className="text-base sm:text-lg text-gray-300 max-w-2xl mx-auto leading-relaxed px-2 font-sans">
            Encuentra respuestas a las preguntas más comunes sobre nuestras sesiones navideñas.
          </p>
        </div>

        {/* Lista de FAQs */}
        <div className="space-y-4 sm:space-y-6">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-gradient-to-b from-gray-900/60 to-gray-800/40 backdrop-blur-sm border border-gold-500/30 rounded-2xl overflow-hidden transition-all duration-300 hover:border-gold-500/50"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 sm:px-8 py-4 sm:py-6 text-left flex items-center justify-between cursor-pointer hover:bg-gray-800/20 transition-colors"
              >
                <h3 className="text-base sm:text-lg font-semibold pr-4 text-gold-500 font-serif">
                  {faq.question}
                </h3>
                <div className="flex-shrink-0">
                  <i 
                    className={`ri-arrow-down-s-line text-xl transition-transform duration-300 text-gold-500 ${
                      openFAQ === index ? 'rotate-180' : ''
                    }`}
                  ></i>
                </div>
              </button>
              
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openFAQ === index ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-6 sm:px-8 pb-4 sm:pb-6">
                  <div className="border-t border-gold-500/30 pt-4">
                    <p className="text-sm sm:text-base text-gray-300 leading-relaxed font-sans">
                      {faq.answer}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA adicional */}
        <div className="text-center mt-12 sm:mt-16">
          <p className="text-base sm:text-lg text-gray-300 mb-6 font-sans">
            ¿Tienes más preguntas? Estamos aquí para ayudarte.
          </p>
          <a 
            href="https://api.whatsapp.com/send?phone=17874599755&text=Hola%20Idoel,%20Estamos%20interesados%20en%20las%20sesiones%20de%20navidad"
            target="_blank"
            rel="noopener noreferrer"
            className="text-black font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-xl transition-all duration-300 whitespace-nowrap cursor-pointer bg-gradient-to-r from-gold-500 to-gold-600 hover:from-gold-600 hover:to-gold-700 font-sans inline-block"
          >
            Contáctame por Whatsapp
          </a>
        </div>
      </div>
    </section>
  );
}
